import { Link } from 'react-router-dom';
import { getLatestComics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latestComics = getLatestComics(8);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h3 className="text-xl md:text-2xl font-heading text-foreground-900">最近更新</h3>
            <p className="text-sm text-foreground-500 mt-1">最新更新的漫画章节</p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-product-shop>
          {latestComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200 transition-colors cursor-pointer group"
            >
              <div className="w-20 h-28 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {comic.title}
                  </h4>
                  <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                </div>
                <div>
                  <p className="text-xs text-primary-500 font-medium">
                    更新至第{comic.chapters.length}话
                  </p>
                  <p className="text-xs text-foreground-400 mt-0.5">{comic.updatedAt}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}